import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    apiListCustomers,
    apiListMachines,
    apiListMachineTypes,
    apiListRoles,
    apiListServiceStaffs,
    apiListTerms,
} from 'Services/AdminService'

export const getRoles = createAsyncThunk('admin/list/getRoles', async () => {
    const { data } = await apiListRoles()
    return data
})

export const getMachineTypes = createAsyncThunk('admin/list/getMachineTypes', async () => {
    const { data } = await apiListMachineTypes()
    return data
})

export const getMachines = createAsyncThunk('admin/list/getMachines', async () => {
    const { data } = await apiListMachines()
    return data
})

export const getTerms = createAsyncThunk('admin/list/getTerms', async () => {
    const { data } = await apiListTerms()
    return data
})

export const getCustomers = createAsyncThunk('admin/list/getCustomers', async () => {
    const { data } = await apiListCustomers()
    return data
})

export const getServiceStaffs = createAsyncThunk('admin/list/getServiceStaffs', async () => {
    const { data } = await apiListServiceStaffs()
    return data
})

export const listSlice = createSlice({
    name: 'admin/list',
    initialState: {
        loading: true,
        roles: [],
        machine_types: [],
        machines: [],
        terms: [],
        customers: [],
        service_staffs: [],
    },
    extraReducers: builder => {
        const handle = (thunk, key) =>
            builder
                .addCase(thunk.pending, state => {
                    state.loading = true
                })
                .addCase(thunk.fulfilled, (state, { payload }) => {
                    state.loading = false
                    state[key] = payload
                })
                .addCase(thunk.rejected, state => {
                    state.loading = false
                    state[key] = []
                })

        handle(getRoles, 'roles')
        handle(getMachineTypes, 'machine_types')
        handle(getMachines, 'machines')
        handle(getTerms, 'terms')
        handle(getCustomers, 'customers')
        handle(getServiceStaffs, 'service_staffs')
    },
})

export default listSlice.reducer
